import m from "../../geodata/es2015/zimbabweLow";
window.am4geodata_zimbabweLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/zimbabweLow.js
// module id = null
// module chunks = 